import {
  TextareaProps as MantineTextareaProps,
  Textarea as MantineTextarea,
} from '@mantine/core';

export type TextareaProps = MantineTextareaProps;

export const Textarea = MantineTextarea;

Textarea.displayName = 'Textarea';
